// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__raaH1","select":"styles_select__HZqjQ","ellipsis-container":"styles_ellipsis-container__9VZSy","hidden":"styles_hidden__66pz2"};